import { FC } from "react";
import {
  Wrapper,
  Title,
  LocationWrapper,
  DateWrapper,
  InfoWrapper,
  Image,
  CatagoryWrapper,
} from "./EventCard.styled";
import { GoLocation } from "react-icons/go";
import DateTime from "Components/DateTime";
import Link from "next/link";

type Props = {
  event: {
    catagory: string;
    img?: string;
    title: string;
    startDate: number;
    endDate: string;
    location: string;
    category: string;
    name: string;
    createdAt: number;
    publication: string;
  };
};

const EventCard: FC<Props> = ({ event }) => {
  const images: { [unit: string]: string } = {
    "Car boot and jumble sales": "arts",
    "Clubs / groups / societies": "arts",
    "Charity events": "giving",
    "Family fun days / events": "talking",
    "Film": "theatre",
    "Markets": "food",
    "On stage (music, theatre, performance)": "theatre",
    "Sports / fitness / outdoors activities": "food",
    "Students": "food",
    "Other": "food",
  }

    const image = (event.img && event.img !== "")
      ? event.img
      : `/images/event_types/${images[event.category]}.png`;
  return (
    <Link
      href={`/whats-on/${event.publication}_${
        event.createdAt
      }_${encodeURIComponent(event.name)}`}
    >
      <Wrapper>
        <Image image={image}>
          <CatagoryWrapper>{event.category}</CatagoryWrapper>
        </Image>
        <InfoWrapper>
          <Title>{event.name}</Title>
          <DateWrapper>
            <DateTime time={new Date(event.startDate)} type="short" />
            {event.endDate && (
              <>
                {" "}
                - <DateTime time={new Date(event.endDate)} type="short" />
              </>
            )}
          </DateWrapper>

          <LocationWrapper>
            <GoLocation />
            <span>{event.location}</span>
          </LocationWrapper>
        </InfoWrapper>
      </Wrapper>
    </Link>
  );
};
export default EventCard;
